import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "script-lifespan"
    }}>{`Script lifespan`}</h1>
    <p>{`UXP scripts, like JavaScript, are single-threaded and non-blocking. It lives until the last statement in the execution stack.`}</p>
    <p>{`Let's understand this with a very simple example.`}</p>
    <CodeBlock slots="heading, code" repeat="2" languages="JavaScript, Text" mdxType="CodeBlock" />
    <h4 {...{
      "id": "sampleidjs"
    }}>{`sample.idjs`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`console.log("Start of execution.");

function foo() {
    console.log("Greetings: Hello");
}

foo();

console.log("End of execution.");
`}</code></pre>
    <h4 {...{
      "id": "output"
    }}>{`Output`}</h4>
    <pre><code parentName="pre" {...{}}>{`Start of execution
Greetings: Hello
End of execution
`}</code></pre>
    <p>{`In the above code, the script is considered to be complete or done once it executes the last line. It is no longer alive after the last line - "End of execution". This is the standard way in which how JavaScript execution stack work. Learn about the `}<a parentName="p" {...{
        "href": "https://www.javascripttutorial.net/javascript-call-stack/"
      }}>{`execution stack`}</a>{`, if you are not already familiar with it. `}</p>
    <InlineAlert variant="info" slots="text1, text2, text3" mdxType="InlineAlert" />
    <p><strong parentName="p">{`Pro tip`}</strong></p>
    <p>{`While debugging your scripts, adding a breakpoint to the last statement will help in seeing all the `}<inlineCode parentName="p">{`console.logs`}</inlineCode>{` before they disappear when the script completes and debug window closes.`}</p>
    <p>{`It's also worth noting that a script session too coincides with its lifespan. Every execution is a different session. `}</p>
    <p>{`The above example also showcases pure synchronous operations. Such operations are always executed sequentially.`}</p>
    <p>{`However, things are a little complicated when we speak about asynchronous tasks. An async task usually happens at a later point in time and the execution thread doesn't wait around for it to complete. (If you are not familiar with synchronous/asynchronous operations in JavaScript, here's an article that explains the `}<a parentName="p" {...{
        "href": "https://www.freecodecamp.org/news/synchronous-vs-asynchronous-in-javascript/"
      }}>{`difference`}</a>{`)`}</p>
    <p>{`Since UXP scripts only live until it reaches the last statement in the call stack, they may no longer be alive, for the asynchronous tasks to execute at a later point in time. Almost as if it expects your code to be synchronous at all times.`}</p>
    <p>{`We understand that in real-world use cases, this is not possible. A network call is asynchronous and it may take a few seconds for it to resolve. And the script should wait for such operations somehow. So how do we handle such scenarios? By using `}<inlineCode parentName="p">{`global await`}</inlineCode>{`, which makes asynchronous code behave like synchronous operations. We will learn about it in the next section.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      